import { ProxyEventType } from "src/store/proxyEvent/types";

export function isVotingFiling(proxyEvent: { type: ProxyEventType | string }) {
  const { type } = proxyEvent;
  return (
    type === "annual_meeting" ||
    type === "special_meeting" ||
    type === "contested_annual_meeting" ||
    type === "contested_special_meeting" ||
    type === "consent_solicitation"
  );
}
